export default {
  title: {
    id: 'cookies_page_title',
    defaultMessage: 'Stating your preferences',
  },
  save: {
    id: 'cookies_page_save',
    defaultMessage: 'Save',
  },
  titleSeo: {
    id: 'cookies_page_title_seo',
    defaultMessage: 'Cookies',
  },

  toastSuccessTitle: {
    id: 'cookies_settings_toast_success_title',
    defaultMessage: 'Perfect!',
  },
  toastSuccessMessage: {
    id: 'cookies_settings_toast_success_message',
    defaultMessage: 'Your settings have been saved!',
  },
  toastErrorTitle: {
    id: 'cookies_settings_toast_error_title',
    defaultMessage: 'Oops!',
  },
  toastErrorMessage: {
    id: 'cookies_settings_toast_error_message',
    defaultMessage: 'Something went wrong',
  },
}
